/**
 * @generated SignedSource<<bcfa7873caf30721ba99031d082a42ff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IdentityProviders_query$data = {
  readonly cloudOrganizations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly syncOptions: {
          readonly syncGroups: boolean;
          readonly syncResourceViewerRoles: boolean;
        };
        readonly " $fragmentSpreads": FragmentRefs<"CloudOrganizationCard_organization">;
      };
    }> | null | undefined;
  };
  readonly samlProviders: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"SamlProviderCard_provider">;
  }>;
  readonly " $fragmentType": "IdentityProviders_query";
};
export type IdentityProviders_query$key = {
  readonly " $data"?: IdentityProviders_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"IdentityProviders_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IdentityProviders_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SAMLProvider",
      "kind": "LinkedField",
      "name": "samlProviders",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SamlProviderCard_provider"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "CloudOrganizationConnection",
      "kind": "LinkedField",
      "name": "cloudOrganizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CloudOrganizationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CloudOrganization",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SyncOptions",
                  "kind": "LinkedField",
                  "name": "syncOptions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "syncGroups",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "syncResourceViewerRoles",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CloudOrganizationCard_organization"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "cloudOrganizations(first:100)"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a05cb45cc808e35ba6711403a3ecad59";

export default node;
